import React from 'react';

import BlogPostCard from '@/components/route/blog/BlogPostCard/BlogPostCard';
import { IBlogPost } from '@/services/types/blog/post.types';

import css from './CategoryPosts.module.css';

interface ICategoryPost {
  posts: IBlogPost[];
  inline?: boolean;
}

const CategoryPosts: React.FC<ICategoryPost> = ({ posts, inline = false }) => {
  return (
    <div
      className={`w-full mx-auto mt-4 grid gap-0 lg:gap-5 lg:max-w-none ${
        inline ? css.wrapper : 'grid-cols-1 gap-4 lg:grid-cols-3'
      }`}>
      {posts.map(p => (
        <div key={p.id} className={inline ? css.card : ''}>
          <BlogPostCard post={p} ratio="1.1:1" />
        </div>
      ))}
    </div>
  );
};

export default CategoryPosts;
